import { regExValidator } from '../../shared/validators/reg-ex.validator';

export const nwNumberRegExValidator = regExValidator(new RegExp('^NW\\d{3}$'), 'NW-Number must match NW000');
export const nwNumberDefaultPlaceholer = 'e.g. NW405';
